import styled from '@emotion/styled';

export const ExpandRegion = styled('div', {
  shouldForwardProp: (prop) => prop !== '$open',
})<{ $open: boolean }>(({ $open }) => ({
  display: 'grid',
  gridTemplateRows: $open ? '1fr' : '0fr',
  transition: 'grid-template-rows 0.25s ease',

  '& > *': {
    overflow: 'hidden',
    minHeight: 0,
  },
}));
